/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminDatasetCategoryPost = {
  id: 'admin-dataset-category.post',
  tag: 'Admin',
  summary: 'Admin Create Dataset Category',
  description: 'Create dataset category',
  method: 'post',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => '/administration/dataset-category',
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            identifier: z.string(),
            thumbnail: z.string(),
            i18n: z.array(
              z.strictObject({
                title: z.string(),
                language: ZodTypes.Language,
              }),
            ),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
